/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScrapedRoomContentItem } from './ScrapedRoomContentItem';
import {
    ScrapedRoomContentItemFromJSON,
    ScrapedRoomContentItemFromJSONTyped,
    ScrapedRoomContentItemToJSON,
    ScrapedRoomContentItemToJSONTyped,
} from './ScrapedRoomContentItem';

/**
 * Bulk request to save scraped room content
 * @export
 * @interface ScrapedRoomContentBulkRequest
 */
export interface ScrapedRoomContentBulkRequest {
    /**
     * Hotel chain name (e.g., marriott, hilton, hyatt)
     * @type {string}
     * @memberof ScrapedRoomContentBulkRequest
     */
    chainName: string;
    /**
     * 
     * @type {Array<ScrapedRoomContentItem>}
     * @memberof ScrapedRoomContentBulkRequest
     */
    items: Array<ScrapedRoomContentItem>;
}

/**
 * Check if a given object implements the ScrapedRoomContentBulkRequest interface.
 */
export function instanceOfScrapedRoomContentBulkRequest(value: object): value is ScrapedRoomContentBulkRequest {
    if (!('chainName' in value) || value['chainName'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ScrapedRoomContentBulkRequestFromJSON(json: any): ScrapedRoomContentBulkRequest {
    return ScrapedRoomContentBulkRequestFromJSONTyped(json, false);
}

export function ScrapedRoomContentBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrapedRoomContentBulkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'chainName': json['chain_name'],
        'items': ((json['items'] as Array<any>).map(ScrapedRoomContentItemFromJSON)),
    };
}

export function ScrapedRoomContentBulkRequestToJSON(json: any): ScrapedRoomContentBulkRequest {
    return ScrapedRoomContentBulkRequestToJSONTyped(json, false);
}

export function ScrapedRoomContentBulkRequestToJSONTyped(value?: ScrapedRoomContentBulkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chain_name': value['chainName'],
        'items': ((value['items'] as Array<any>).map(ScrapedRoomContentItemToJSON)),
    };
}

